import { Avatar } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekAvatar = styled(Avatar)(({ theme }) => ({
    "& .MuiAvatar-badge": Object.assign(Object.assign({}, theme.typography.body2), { fontWeight: theme.typography.fontWeightBold }),
}));

export { PeekAvatar, PeekAvatar as default };
